import FW from '../fw/fw';
import Logger from '../fw/logger';


export default class AdsRmpVast {

  #rmp;
  #onRmpVastAdPlayPauseFn = null;
  #onAdTagStartLoadingFn = null;
  #onRmpVastAdStartedFn = null;
  #onRmpVastAdDestroyedFn = null;
  #onRmpVastAdErrorFn = null;
  #onRmpVastAdInteractionFn = null;
  #onRmpVastAdLinearChangedFn = null;
  #adErrorDetected = false;

  constructor(rmp) {
    this.#rmp = rmp;
  }

  #unwireAdEvents() {
    Logger.print('rmp-vast', 'unwire ad events');
    this.#rmp.rmpAdsHelpers.clearAdRemainingTimeBarInterval();
    this.#rmp.off('adresumed adpaused', this.#onRmpVastAdPlayPauseFn);
    this.#rmp.off('adtagstartloading', this.#onAdTagStartLoadingFn);
    this.#rmp.off('adstarted', this.#onRmpVastAdStartedFn);
    this.#rmp.off('addestroyed', this.#onRmpVastAdDestroyedFn);
    this.#rmp.off('aderror', this.#onRmpVastAdErrorFn);
    this.#rmp.off('adinteraction', this.#onRmpVastAdInteractionFn);
    this.#rmp.off('adlinearchange', this.#onRmpVastAdLinearChangedFn);
  }

  #handleRmpVastAdPod() {
    // adpod for VMAP
    this.#rmp.rmpVastAdPodInfo = this.#rmp.rmpVast.adPodInfo;
    FW.setText(this.#rmp.dom.adPod, '');
    if (this.#rmp.rmpVastAdPodInfo && this.#rmp.dom.adInfo) {
      const totalAds = this.#rmp.rmpVastAdPodInfo.adPodLength;
      if (typeof totalAds === 'number' && totalAds > 1) {
        Logger.print('rmp-vast', 'adpod detected with ' + totalAds + ' ads - current index is ' + this.#rmp.rmpVastAdPodInfo.adPodCurrentIndex);
        if (!this.#rmp.dom.adPod) {
          this.#rmp.dom.adPod = FW.createElement('span', 'rmp-ad-info-pod');
          if (this.#rmp.dom.adCountdown) {
            FW.insertBefore(this.#rmp.dom.adInfo, this.#rmp.dom.adPod, this.#rmp.dom.adCountdown);
          } else {
            this.#rmp.dom.adInfo.appendChild(this.#rmp.dom.adPod);
          }
        }
        const adPosition = this.#rmp.rmpVastAdPodInfo.adPodCurrentIndex;
        if (typeof adPosition === 'number') {
          FW.setText(this.#rmp.dom.adPod, adPosition + '/' + totalAds);
        }
      }
    }
  }

  #onRmpVastAdStarted() {
    if (this.#rmp.googleCastConnected) {
      Logger.print('google-cast', 'casting is engaged - cancelling ad request');
      this.#rmp.stopAds().catch(error => {
        this.#rmp.rmpUtils.warning(1021, error);
      });
      this.#rmp.play().catch(error => {
        this.#rmp.rmpUtils.warning(1014, error);
      });
      return;
    }
    // in case player in FS before ad starts
    this.#rmp.resize();
    // reset non linear UI
    const adContainer = this.#rmp.dom.container.querySelector('.rmp-ad-container');
    if (adContainer) {
      adContainer.classList.remove('rmp-ad-overlay');
    }
    const adLinear = this.#rmp.adLinear;
    // update VPAID status here to hide skip button
    this.#rmp.rmpAdsHelpers.updateVPAIDStatus(adLinear);
    if (adLinear) {
      if (this.#rmp.isVod) {
        this.#rmp.dom.video.removeEventListener('ended', this.#rmp.endedFn);
      }
      this.#rmp.rmpAdsHelpers.udpatePlayPause();
      this.#rmp.rmpAdsHelpers.setUIForAds(true);
      // countdown
      if (this.#rmp.adCountDown && this.#rmp.dom.adInfo) {
        this.#rmp.rmpAdsHelpers.addCountDown();
      }
      if (this.#rmp.adShowRemainingTime) {
        this.#rmp.rmpAdsHelpers.appendRemainingTimeBar();
      }
      // adpod
      if (this.#rmp.rmpVastAdPodInfo === null) {
        this.#handleRmpVastAdPod();
      }
      if (this.#rmp.muted) {
        this.#rmp.rmpAdsHelpers.setAdMute(true);
      } else {
        let currentVolume = this.#rmp.volume;
        this.#rmp.rmpAdsHelpers.setAdVolume(currentVolume);
      }
    } else {
      // only apply rmp-ad-overlay offset if non-linear ad does not take full height of player
      const adNonLinearHeight = this.#rmp.rmpVast.adMediaHeight;
      const playerSize = this.#rmp.getPlayerSize();
      if (adNonLinearHeight > -1 && ((adNonLinearHeight + 40) < playerSize.height) && adContainer) {
        adContainer.classList.add('rmp-ad-overlay');
      }
      // proper handling of offsetStartPosition for non-linear
      if (this.#rmp.offsetStartPosition > 0) {
        this.#rmp.rmpAdsHelpers.seekToOffsetStartPosition();
      }
    }
  }

  #onRmpVastAdDestroyed() {
    this.#rmp.rmpVastAdPodInfo = this.#rmp.rmpVast.adPodInfo;
    if (this.#rmp.rmpVastAdPodInfo.adPodLength > 0 &&
      (this.#rmp.rmpVastAdPodInfo.adPodCurrentIndex !== this.#rmp.rmpVastAdPodInfo.adPodLength)) {
      const adPosition = this.#rmp.rmpVastAdPodInfo.adPodCurrentIndex;
      const totalAds = this.#rmp.rmpVastAdPodInfo.adPodLength;
      if (typeof adPosition === 'number' && typeof totalAds === 'number') {
        FW.setText(this.#rmp.dom.adPod, (adPosition + 1) + '/' + totalAds);
      }
      this.#rmp.one('adstarted', this.#onRmpVastAdStartedFn);
      return;
    }
    this.#rmp.rmpVastAdPodInfo = null;
    if (this.#adErrorDetected) {
      this.#adErrorDetected = false;
      if (Array.isArray(this.#rmp.adTagWaterfall) && typeof this.#rmp.adTagWaterfall[0] === 'string' && this.#rmp.adTagWaterfall[0] !== '') {
        this.#rmp.adTagUrl = this.#rmp.adTagWaterfall[0];
        if (this.#rmp.adTagWaterfall.length > 0) {
          this.#rmp.adTagWaterfall.shift();
        }
        this.#rmp.loadAds(this.#rmp.adTagUrl, ['internal']).catch(error => {
          this.#rmp.rmpUtils.warning(1020, error);
          this.#rmp.rmpUtils.playPromise();
        });
        this.#rmp.dispatch('adclientsidewaterfallrequested');
        return;
      }
    }
    if (this.#rmp.adOutStream) {
      this.#rmp.rmpAdsHelpers.endedOutStreamUI();
      return;
    }
    // need to re-add error handling for iOS/macOS Safari
    if (this.#rmp.readingPDorNative) {
      this.#rmp.rmpUtils.refreshHtml5VideoErrorManagement();
    }
    // proper handling of offsetStartPosition
    if (this.#rmp.offsetStartPosition > 0) {
      this.#rmp.rmpAdsHelpers.seekToOffsetStartPosition();
    }
    this.restoreContentUI();
  }

  #onRmpVastAdError() {
    Logger.print('rmp-vast', 'adErrorMessage - ' + this.#rmp.adErrorMessage);
    Logger.print('rmp-vast', 'adVastErrorCode - ' + this.#rmp.adVastErrorCode);
    Logger.print('rmp-vast', 'adErrorType - ' + this.#rmp.adErrorType);
    this.#adErrorDetected = true;
  }

  #onRmpVastAdPlayPause() {
    this.#rmp.rmpAdsHelpers.udpatePlayPause();
  }

  #onRmpVastAdInteraction() {
    this.#rmp.dispatch('adinteraction');
  }

  #onRmpVastAdLinearChanged() {
    this.#rmp.dispatch('adlinearchanged');
  }

  #onAdTagStartLoading() {
    // need to remove error handling for iOS/macOS Safari
    if (this.#rmp.readingPDorNative) {
      this.#rmp.dom.video.removeEventListener('error', this.#rmp.generateErrorFn, true);
    }
    this.#onRmpVastAdPlayPauseFn = this.#onRmpVastAdPlayPause.bind(this);
    this.#rmp.on('adresumed', this.#onRmpVastAdPlayPauseFn);
    this.#rmp.on('adpaused', this.#onRmpVastAdPlayPauseFn);
    this.#onRmpVastAdStartedFn = this.#onRmpVastAdStarted.bind(this);
    this.#rmp.one('adstarted', this.#onRmpVastAdStartedFn);

    this.#onRmpVastAdDestroyedFn = this.#onRmpVastAdDestroyed.bind(this);
    this.#rmp.on('addestroyed', this.#onRmpVastAdDestroyedFn);

    this.#onRmpVastAdErrorFn = this.#onRmpVastAdError.bind(this);
    this.#rmp.on('aderror', this.#onRmpVastAdErrorFn);

    this.#onRmpVastAdInteractionFn = this.#onRmpVastAdInteraction.bind(this);
    this.#rmp.on('adinteraction', this.#onRmpVastAdInteractionFn);

    this.#onRmpVastAdLinearChangedFn = this.#onRmpVastAdLinearChanged.bind(this);
    this.#rmp.on('adlinearchange', this.#onRmpVastAdLinearChangedFn);
  }

  #transferEvents() {
    const events = [
      'adloaded',
      'addurationchange',
      'adclick',
      'adclosed',
      'adimpression',
      'adcollapse',
      'adstarted',
      'adtagloaded',
      'adprogress',
      'adviewable',
      'adviewundetermined',
      'adinitialplayrequestfailed',
      'adinitialplayrequestsucceeded',
      'adpaused',
      'adresumed',
      'adtagstartloading',
      'advolumemuted',
      'advolumechanged',
      'adcomplete',
      'adskipped',
      'adskippablestatechanged',
      'adfirstquartile',
      'admidpoint',
      'adthirdquartile',
      'aderror',
      'addestroyed',
      'adpodcompleted',
      'adlinearchange',
      'adsizechange',
      'adexpandedchange',
      'adremainingtimechange',
      'adinteraction',
      'aduseracceptinvitation',
      'adcollapse'
    ];
    events.forEach(eventItem => {
      this.#rmp.rmpVast.on(eventItem, () => {
        this.#rmp.dispatch(eventItem);
      });
    });
  }

  #runRmpVast() {
    Logger.print('rmp-vast', 'init at ' + (FW.getNow() - this.#rmp.refTime) + ' ms');
    this.#rmp.adParserLoaded = true;
    const vastXmlPattern = /^<\?xml.+\?>/i;
    let vastXmlInput = false;
    if (vastXmlPattern.test(this.#rmp.adTagUrl)) {
      vastXmlInput = true;
    }
    const params = {
      vastXmlInput,
      omidSupport: this.#rmp.adOmidSupport,
      omidAllowedVendors: this.#rmp.omidAllowedVendors,
      omidAutoplay: this.#rmp.autoplay,
      partnerName: 'radiantmediaplayer',
      partnerVersion: this.#rmp.playerVersion,
      creativeLoadTimeout: this.#rmp.adLoadMediaTimeout,
      ajaxWithCredentials: this.#rmp.adAjaxWithCredentials,
      maxNumRedirects: this.#rmp.adMaxNumRedirects,
      debugRawConsoleLogs: this.#rmp.debugForceRawConsoleLogs,
      labels: {
        skipMessage: this.#rmp.labels.ads.skipMessage,
        closeAd: this.#rmp.labels.hint.close,
        textForInteractionUIOnMobile: this.#rmp.labels.ads.textForClickUIOnMobile,
      },
      outstream: this.#rmp.adOutStream,
      enableSimid: this.#rmp.adRmpVastEnableSimid,
      useHlsJS: this.#rmp.adSupportHlsCreatives,
      showControlsForAdPlayer: false
    };
    if (this.#rmp.adRmpVastEnableVpaid) {
      params.enableVpaid = this.#rmp.adRmpVastEnableVpaid;
      let viewMode = 'normal';
      if (this.#rmp.isInFullscreen) {
        viewMode = 'fullscreen';
      }
      let desiredBitrate = 500;
      if (window.rmpGlobals.rmpConnection.bandwidthData.estimate > 0) {
        desiredBitrate = window.rmpGlobals.rmpConnection.bandwidthData.estimate * 1000 * 0.75;
      }
      const playerSize = this.#rmp.getPlayerSize();
      params.vpaidSettings = {
        width: playerSize.width,
        height: playerSize.height,
        viewMode,
        desiredBitrate
      };
    }
    this.#rmp.rmpVast = new window.RmpVast(this.#rmp.dom.container, params);
    this.#transferEvents();
    this.#rmp.rmpAdsHelpers.createControlBarAdInfo();
    this.#rmp.rmpReadyManagement.fire();
  }

  #rmpVastLoadError() {
    this.#rmp.rmpUtils.warning(10000);
    this.#rmp.adParserLoadError = true;
    this.#rmp.ads = false;
    this.#rmp.rmpReadyManagement.fire();
    this.#rmp.dispatch('adblock');
    // this needs to go after ready so that API is available
    if (this.#rmp.adOutStream) {
      this.#rmp.rmpAdsHelpers.endedOutStreamUI();
    }
  }

  requestRmpVastAds(adTag) {
    Logger.print('rmp-vast', 'loadAds called with ' + adTag);
    // reset VPAID - will need to rely on adloded as IMA when VMAP support comes in
    this.#rmp.isVPAID = false;
    // do not show spinner when loadAds is called after content has started
    const currentTime = this.#rmp.currentTime;
    if (currentTime === 0) {
      this.#rmp.rmpUIManagement.showLoadingSpin();
    }
    this.#rmp.on('adstarted aderror', () => {
      this.#rmp.rmpUIManagement.hideLoadingSpin();
    });
    // this is required when calling loadAds when an ad is onstage to avoid addestroyed to call 
    // restoreContentUI while a new add is being loaded
    this.#onAdTagStartLoadingFn = this.#onAdTagStartLoading.bind(this);
    this.#rmp.one('adtagstartloading', this.#onAdTagStartLoadingFn);
    const filteredAdTag = adTag.trim();
    try {
      this.#rmp.rmpVast.loadAds(filteredAdTag);
    } catch (warning) {
      console.warn(warning);
    }
  }

  restoreContentUI() {
    this.#unwireAdEvents();
    this.#rmp.rmpAdsHelpers.setUIForAds(false);
    if (this.#rmp.isVod) {
      this.#rmp.rmpUtils.refreshHtml5VideoEndedManagement();
    }
    // if postroll we need to pause after postroll
    const duration = this.#rmp.duration;
    const currentTime = this.#rmp.currentTime;
    if (duration > -1 && currentTime > -1 && currentTime === duration) {
      this.#rmp.rmpEventsManagement.pauseCallback();
    }
  }

  init() {
    if (typeof window.RmpVast !== 'undefined') {
      this.#runRmpVast();
    } else {
      // do not change to const pathToRmpFiles = this.#rmp.pathToRmpFiles or grunt replace won't work
      let callScript = this.#rmp.pathToRmpFiles + 'rmp-vast/rmp-vast.min.js';
      if (DEBUG) {
        callScript = this.#rmp.pathToRmpFiles + 'rmp-vast/rmp-vast.js';
      }
      Logger.print('rmp-vast', 'starts loading rmp-vast lib at ' + (FW.getNow() - this.#rmp.refTime) + ' ms');
      FW.getScript(
        callScript,
        this.#runRmpVast.bind(this),
        this.#rmpVastLoadError.bind(this),
        this.#rmp.shadowRoot
      );
    }
  }

  resumeRmpVastAds() {
    if (this.#rmp.rmpVast) {
      this.#rmp.rmpVast.play();
    }
  }

  pauseRmpVastAds() {
    if (this.#rmp.rmpVast) {
      this.#rmp.rmpVast.pause();
    }
  }

}
